import React, { Component } from "react";
import "./index.css";
import { connect } from "../../utils";

class EmptyView extends Component {
  render() {
    return <div />;
  }
}
export default connect("layoutState")(EmptyView);



// WEBPACK FOOTER //
// ./src/contents/editorPreview/layout/components/Layout/EmptyView.js